/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'
import {useDispatch, useSelector} from 'react-redux'
import {useIntl} from 'react-intl'
import {useThemeMode} from '../theme-mode/ThemeModeProvider'
import {Modal} from 'react-bootstrap'
import {setIsThereNonSavedForm, setUserProfileData} from '../../../../app/common/ModalPopup/reducer'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  // const navigate = useNavigate()
  const isThereNonSavedForm = useSelector((state: any) => state?.isThereNonSavedForm)
  const [showCancel, setShowCancel] = useState<boolean>(false)
  const [w2go, setW2go] = useState<string>('')
  const navigate = useNavigate()
  const intl = useIntl()
  const {mode} = useThemeMode()
  const dispatch = useDispatch()

  const checkEditNonSaved = (e: any, routeName: string, action: Function =()  =>{}) => {
    setW2go(routeName)
    if (isThereNonSavedForm === true) {
      setShowCancel(true)
    } else {
      //logout()
      action()
      dispatch(setUserProfileData(null))
      navigate(
          routeName, //{replace: true}
      )
    }
  }



  const onCancelReset = () => {
    setShowCancel(false)
  }

  const onConfirmCancel = () => {
    setShowCancel(false)
    dispatch(setIsThereNonSavedForm(false))
    logout()
    navigate(w2go, {replace: true})
  }
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-semibold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5 '>
            <img
              alt='Logo'
              src={
                currentUser?.Photo && currentUser?.Photo !== ''
                  ? `${currentUser?.Photo}`
                  : toAbsoluteUrl('/media/avatars/blank.png')
              }
              className='rounded-circle'
            />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bold d-flex align-items-center fs-5'>
              {currentUser?.FirstName} {currentUser?.LastName}
            </div>
            <a href='#' className='fw-semibold text-muted text-hover-primary fs-7'>
              {currentUser?.Email}
            </a>
          </div>
        </div>
      </div>
      <Languages />

      <div className='menu-item px-5 my-1'>
        <Link
          to='/crafted/account/settings'
          className='menu-link px-5'
          onClick={(e) => {
            e.preventDefault()
            checkEditNonSaved(e, '/crafted/account/settings')
          }}
        >
          Paramètres du compte
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a
          onClick={(e) => {
            e.preventDefault()
            checkEditNonSaved(e, '/',logout)
          }}
          className='menu-link px-5'
        >
          Se déconnecter
        </a>
      </div>
      <Modal show={showCancel} centered>
        <div className='text-center p-5 w-100' data-bs-theme={mode}>
          <div
            className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
            data-bs-theme={mode}
          >
            <div className='d-flex align-items-center justify-content-between'>
              <div className='fw-bolder text-gray-700 py-3'>
                {intl.formatMessage({id: 'INFORMATION'})}
              </div>
              <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                <i className='fa fa-close text-danger'></i>
              </div>
            </div>
            <div className={'text-start py-3'}>
              <div>{intl.formatMessage({id: 'BEFORE_QUIT_CONFIRM_MESSAGE'})}</div>
            </div>
            <div className='d-flex align-items-center justify-content-evenly'>
              <button className={'btn btn-secondary'} onClick={onCancelReset}>
                {intl.formatMessage({id: 'NO'})}
              </button>
              <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                {intl.formatMessage({id: 'YES'})}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export {HeaderUserMenu}
